var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex-center-column home-process" }, [
    _c("div", { staticClass: "title-zh" }, [_vm._v("入驻流程")]),
    _c("div", { staticClass: "title-en" }, [_vm._v("ENTRY PROCESS")]),
    _vm._m(0),
    false
      ? _c(
          "div",
          { staticClass: "btn-box" },
          [
            _c(
              "el-button",
              {
                staticClass: "apple-btn",
                attrs: { type: "primary", round: "" },
                on: {
                  click: function ($event) {
                    return _vm.goApply()
                  },
                },
              },
              [_vm._v("申请入驻")]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "flex-row-space-between-hCenter process-list" },
      [
        _c("div", { staticClass: "flex-row-h-center process-item" }, [
          _c("img", {
            staticClass: "left-img",
            attrs: { src: require("@/assets/home/process_1.png"), alt: "" },
          }),
          _c("div", { staticClass: "index-dec" }, [
            _c("img", {
              staticClass: "index-img",
              attrs: { src: require("@/assets/01.png"), alt: "" },
            }),
            _c("span", { staticClass: "dec" }, [_vm._v("提交入驻资料")]),
          ]),
        ]),
        _c("div", { staticClass: "arrow" }, [
          _c("img", {
            attrs: { src: require("@/assets/home/arrow.png"), alt: "" },
          }),
        ]),
        _c("div", { staticClass: "flex-row-h-center process-item" }, [
          _c("img", {
            staticClass: "left-img",
            attrs: { src: require("@/assets/home/process_4.png"), alt: "" },
          }),
          _c("div", { staticClass: "index-dec" }, [
            _c("img", {
              staticClass: "index-img",
              attrs: { src: require("@/assets/02.png"), alt: "" },
            }),
            _c("span", { staticClass: "dec" }, [_vm._v("机构入驻成功")]),
          ]),
        ]),
        _c("div", { staticClass: "arrow" }, [
          _c("img", {
            attrs: { src: require("@/assets/home/arrow.png"), alt: "" },
          }),
        ]),
        _c("div", { staticClass: "flex-row-h-center process-item" }, [
          _c("img", {
            staticClass: "left-img",
            attrs: { src: require("@/assets/home/process_2.png"), alt: "" },
          }),
          _c("div", { staticClass: "index-dec" }, [
            _c("img", {
              staticClass: "index-img",
              attrs: { src: require("@/assets/03.png"), alt: "" },
            }),
            _c("span", { staticClass: "dec" }, [_vm._v("邀请签约达人")]),
          ]),
        ]),
        _c("div", { staticClass: "arrow" }, [
          _c("img", {
            attrs: { src: require("@/assets/home/arrow.png"), alt: "" },
          }),
        ]),
        _c("div", { staticClass: "flex-row-h-center process-item" }, [
          _c("img", {
            staticClass: "left-img",
            attrs: { src: require("@/assets/home/process_3.png"), alt: "" },
          }),
          _c("div", { staticClass: "index-dec" }, [
            _c("img", {
              staticClass: "index-img",
              attrs: { src: require("@/assets/04.png"), alt: "" },
            }),
            _c("span", { staticClass: "dec" }, [_vm._v("达人接受邀约")]),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }